
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as QuickbooksSvg } from '../media/quickbooks.svg';
import { Button } from '@mui/material';
import { connect } from 'react-redux';
import { hasIntersection } from '../../../shared/utils';
import { USER_ROLE } from '../../../shared/constants';

function _ConnectToQuickbooksButton({ onClick, size, disabled }) {

   return <Button
      variant="contained"
      startIcon={<SvgIcon component={QuickbooksSvg} inheritViewBox />}
      onClick={onClick}
      className="px-4 rounded-full"
      size={size}
      title='Connect to Quickbooks'
      disabled={disabled}
   >
      Connect
   </Button>
}

const mapStateToProps = (state) => {
   const roles = state.user?.roles || [];
   const disabled = !hasIntersection(roles, [ USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN ]);
   return {
      disabled,
   };
}

const ConnectEntityToQuickbooksButton = connect(mapStateToProps)(_ConnectToQuickbooksButton);
export default ConnectEntityToQuickbooksButton;